import { mapGetters, mapMutations } from 'vuex';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

export default {
    name: 'searchSort',
    inject: ['$eventBus'],
    props: {
        disableReset: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        mvtDropdownList,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp']),
        sortBy: {
            set(val) {
                this.updateFilterTrigger('sort');
                this.$eventBus.$emit('eventbus-updatefilter', { sort: val });
            },
            get() {
                return this.msp.filter.sort;
            },
        },
        sortByData() {
            const preLabel = 'Sort by: ';
            const sortByData = [
                { text: this.molang('search.sort.relevant'), value: null, urlKey: 'recommend' },
                { text: this.molang('search.sort.priceLow'), value: 'sortby-price-asc', urlKey: 'lowestPrice' },
                { text: this.molang('search.sort.priceHigh'), value: 'sortby-price-desc', urlKey: 'highestPrice' },
                { text: 'Newest', value: 'sortby-dom-asc', urlKey: 'newest' },
                { text: 'Oldest', value: 'sortby-dom-desc', urlKey: 'oldest' },
                { text: this.molang('search.sort.updatedTimeDesc'), value: 'sortby-updated-desc', urlKey: 'updatedDesc' },
                { text: 'Best Value', value: 'sortby-pricepersqft-asc', urlKey: 'pricepersqftLeast' },
                { text: 'Investment', value: 'sortby-investment-asc', urlKey: 'investment' },
                { text: this.molang('search.sort.lotBig'), value: 'sortby-lot-desc', urlKey: 'lotMost' },
                { text: this.molang('search.sort.lotSmall'), value: 'sortby-lot-asc', urlKey: 'lotLeast' },
                { text: this.molang('search.sort.sqftBig'), value: 'sortby-sqft-desc', urlKey: 'sqftMost' },
                { text: this.molang('search.sort.sqftSmall'), value: 'sortby-sqft-asc', urlKey: 'sqftLeast' },
                { text: 'Beds', value: 'sortby-beds-desc', urlKey: 'bedrooms' },
                { text: 'Baths', value: 'sortby-baths-desc', urlKey: 'bathrooms' },
                { text: this.molang('search.sort.distanceasc'), value: 'sortby-distance-asc', urlKey: 'closestAsc' },
            ].map((item) => ({
                ...item,
                labelText: `<i class="icon-sort-down"></i> <span>${preLabel}${item.text}</span>`,
            }));

            if (this.glb.rentals) {
                return sortByData.filter((item) => !item.value || item.value.indexOf('sortby-lot-') === -1);
            }
            return sortByData;
        },
        options() {
            return {
                defaultValue: this.disableReset ? undefined : null,
            };
        },
    },
    methods: {
        ...mapMutations('msp', ['updateFilterTrigger']),
        onOpened() {
            this.$emit('opened');
        },
        onClosed() {
            this.$emit('closed');
        },
    },
};
